"use strict";


//////////////////
// WEBPACK FOOTER
// ./~/@stardust-ui/react-component-event-listener/dist/commonjs/types.js
// module id = 621
// module chunks = 168707334958949